import {
  AdminDollarInput2,
  AdminInput,
  AdminSelect,
  Button,
  CheckCircleIcon,
  Div,
  ErrorToast,
  H5,
  Icon,
  Modal,
  // ModifierType,
  PlusIcon,
  PropsModal,
  XCircleIcon,
} from '@vgrubs/components';
import {
  Availability,
  MenuV2Response,
  ModifierGroupItemV2Response,
  ModifierItemV2Response,
} from 'components/src/types/menu.types';
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Collapsible } from '../../MenyStyled';
import { ModifierBoxComponent } from './ModifierComponents';

export enum ModifierType {
  Price = 'price',
  Option = 'option',
}

const availabilityOptions = (
  <optgroup label="Select Availability">
    <option value={Availability.Available}>In Stock</option>
    <option value={Availability.SoldOut}>Sold Out (Indefinitely)</option>
  </optgroup>
);
const options2 = [
  { name: 'Price Group', value: ModifierType.Price },
  { name: 'Option Group', value: ModifierType.Option },
];

const typeOptions = (
  <optgroup label="Select Group Type">
    {options2.map((r, i) => (
      <option value={r.value} key={i}>
        {r.name}
      </option>
    ))}
  </optgroup>
);

const requiredOptions = [
  { name: 'No', value: 'false' },
  { name: 'Yes', value: 'true' },
];

const requiredOptionsGroup = (
  <optgroup label="Select Group Type">
    {requiredOptions.map((r, i) => (
      <option value={r.value} key={i}>
        {r.name}
      </option>
    ))}
  </optgroup>
);

const choicesOptions = [
  { name: 'Only One', value: 'Only One' },
  { name: 'Set a min-max', value: 'Set a min-max' },
];

const choicesOptionsGroup = (
  <optgroup label="Select Group Type">
    {choicesOptions.map((r, i) => (
      <option value={r.value} key={i}>
        {r.name}
      </option>
    ))}
  </optgroup>
);

export const AddNewModifierGroupModal = ({
  addNewModal,
  closeModal,
  setMenu,
  edit,
}: PropsModal & {
  addNewModal: boolean | ModifierGroupItemV2Response | null;
  setMenu: Dispatch<SetStateAction<MenuV2Response | null>>;
  edit?: boolean;
}) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const [optionGroup, setOptionGroup] = useState(ModifierType.Price);
  const [isRequired, setIsRequired] = useState(requiredOptions[0].value);
  const [choices, setChoices] = useState(choicesOptions[0].value);

  const [selectionsMin, setSelectionsMin] = useState<number | null | undefined>(
    null
  );
  const [selectionsMax, setSelectionsMax] = useState<number | null | undefined>(
    null
  );

  const [optionName, setOptionName] = useState('');
  const [optionPrice, setOptionPrice] = useState(0);
  const [availability, setAvailability] = useState(Availability.Available);
  const handleValueTotalChange = useCallback((val: number) => {
    setOptionPrice(val);
  }, []);

  const [options, setOptions] = useState<ModifierItemV2Response[]>([]);

  const ref = useRef<HTMLDivElement>(null);
  const elementHeight = ref?.current?.clientHeight;
  const [expanded, setExpanded] = useState(false);

  const data = addNewModal;

  const required = isRequired === 'true';

  useEffect(() => {
    if (edit && typeof data === 'object') {
      setName(data?.name || '');
      setDescription(data?.description || '');
      setOptionGroup(data?.type || ModifierType.Price);
      setIsRequired(data?.required ? 'true' : 'false');
      setOptions(data?.options || []);
      setSelectionsMin(data?.selectionsMin || null);
      setSelectionsMax(data?.selectionsMax || null);
      // TODO: add choices
      // setChoices(
      //   data?.optionType === SelectionType.MinMax ? 'Set a min-max' : 'Only One'
      // );
    } else {
      emptyForm();
    }
  }, [data]);

  const emptyForm = () => {
    setName('');
    setDescription('');
    setOptionGroup(ModifierType.Price);
    setIsRequired(requiredOptions[0].value);
    setChoices(choicesOptions[0].value);
    setOptions([]);
    setSelectionsMin(null);
    setSelectionsMax(null);
  };

  async function handleAddModifierGroup() {
    if (!name) return ErrorToast('Please enter modifier group name');
    // if (!description) return ErrorToast('Please modifier group notes');
    if (options.length < 1) return ErrorToast('Please add options');
    if (
      optionGroup === ModifierType.Option &&
      Number(selectionsMin) > Number(selectionsMax)
    )
      return ErrorToast(
        'Maximum quantity must be grater then or equal to minimum'
      );
    // prettier-ignore
    if (optionGroup === ModifierType.Option && required && (selectionsMin !== null && Number(selectionsMin) < 1))
      return ErrorToast(
        `If it's required choice, Minimum Qty can't be les than 1`
      );

    const uuid = uuidv4();

    const bodyAdd = {
      id: uuid,
      entityId: uuid,
      name,
      description,
      options,
      isRequired: required,
      selectionsMin: selectionsMin ? selectionsMin : null,
      selectionsMax: selectionsMax ? selectionsMax : null,
      dpType: optionGroup,
      optionType: choices === 'Set a min-max' ? 'minMax' : 'onlyOne',
    };

    const bodyEdit = {
      name,
      description,
      options,
      isRequired: required,
      selectionsMin: selectionsMin ? selectionsMin : null,
      selectionsMax: selectionsMax ? selectionsMax : null,
      dpType: optionGroup,
      optionType: choices === 'Set a min-max' ? 'minMax' : 'onlyOne',
      // existingModifier: data,
    };


    // If editing, update the existing modifier group in the menu state
    if (edit && typeof data === 'object') {
      setMenu((prev) => {
        if (!prev) return prev;
        const updated = prev.modifierGroups.map((modifierGroup) => {
          if (modifierGroup.id === data?.id) {
            return { ...modifierGroup, ...bodyEdit };
          } else return modifierGroup;
        });

        return { ...prev, modifierGroups: updated } as MenuV2Response;
      });
    } else {
      // If adding a new modifier group, add it to the appropriate category
      setMenu((prev) => {
        if (!prev) return prev;
        const updated = [...prev.modifierGroups, bodyAdd];

        return { ...prev, modifierGroups: updated } as MenuV2Response;
      });
    }

    emptyForm();
    closeModal?.();
  }

  const handleAddOption = () => {
    if (!optionName) return ErrorToast('Please enter modifier name');
    const uuid = uuidv4();
    setOptions((prev) => [
      ...prev,
      {
        name: optionName,
        description: '',
        price: optionPrice,
        id: uuid,
        entityId: uuid,
        availability,
        modifierGroups: [],
      },
    ]);
    setOptionName('');
    setOptionPrice(0);
    setExpanded(false);
  };

  const handleRemoveOption = (i: number) => {
    const arr = [...options];

    if (i > -1) {
      arr.splice(i, 1);
    }

    setOptions(arr);
  };

  const handleChangeIsRequired = (v: 'true' | 'false') => {
    const required = v === 'true';

    setIsRequired(v);
    if (v === 'true') {
      setSelectionsMin(1);
    } else {
      setSelectionsMin(0);
    }

    if (choices === 'Only One') {
      if (required) {
        setSelectionsMin(1);
        setSelectionsMax(1);
      } else {
        setSelectionsMin(0);
        setSelectionsMax(1);
      }
    }
    if (choices === 'Set a min-max') {
      if (required) {
        setSelectionsMin(1);
        setSelectionsMax(1);
      } else {
        setSelectionsMin(0);
        setSelectionsMax(0);
      }
    }
  };

  const handleChangeChoices = (v: 'Only One' | 'Set a min-max') => {
    setChoices(v);
    if (v === 'Only One') {
      if (required) {
        setSelectionsMin(1);
        setSelectionsMax(1);
      } else {
        setSelectionsMin(0);
        setSelectionsMax(1);
      }
    }
    if (v === 'Set a min-max') {
      if (required) {
        setSelectionsMin(1);
        setSelectionsMax(1);
      } else {
        setSelectionsMin(0);
        setSelectionsMax(0);
      }
    }
  };

  const handleChangeOptionGroup = (v: ModifierType) => {
    setOptionGroup(v);
    if (v === ModifierType.Price) {
      handleChangeIsRequired('true');
    }
    if (v === ModifierType.Option) {
      handleChangeIsRequired('false');
    }
  };

  const handleExpand = () => {
    setExpanded((prev) => !prev);
    handleValueTotalChange(0);
    setOptionName('');
  };

  return (
    <Modal
      isOpen={!!addNewModal}
      closeModal={closeModal}
      header={`${edit ? 'Edit' : 'Add'} Modifier Group`}
      logo={false}
      zIndex={101}
      // width="850px"
    >
      <Div $flex $column $gap="24px">
        <Div $flex $column $alignCenter $gap="16px">
          <AdminInput
            placeholder="Enter Here"
            label="Group Name"
            $textCenter
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <AdminSelect
            value={optionGroup}
            options={typeOptions}
            onChange={({ target }: { target: HTMLSelectElement }) =>
              handleChangeOptionGroup(target.value as ModifierType)
            }
            label="Choose Group Type"
            $textCenter
            disabled={edit}
          />{' '}
        </Div>
        <AdminInput
          placeholder="Add context or internal names for this modifier group. Notes won't be."
          label="Notes"
          $textCenter
          maxLength={30}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          $textareaHeight={150}
        />

        <div>
          <Div
            $mt="8"
            $flex
            $between
            $alignCenter
            $gap="16px"
            $mb={options.length > 0 ? '16' : '0'}
          >
            <H5 $m="0">Modifiers</H5>

            {!expanded && (
              <Icon $pointer onClick={handleExpand}>
                <PlusIcon />
              </Icon>
            )}
          </Div>

          <Collapsible expanded={expanded} elementHeight={elementHeight}>
            <div ref={ref}>
              <Div
                $box={expanded}
                $p="24px 16px"
                $flex
                $column
                $alignCenter
                $gap="16px"
                $width="100%"
              >
                <AdminInput
                  placeholder="Enter Here"
                  label="Modifier Name"
                  $textCenter
                  value={optionName}
                  onChange={(e) => setOptionName(e.target.value)}
                />

                <AdminDollarInput2
                  label="Modifier Price (Not Required)"
                  $textCenter
                  onValueChange={handleValueTotalChange}
                  value={optionPrice}
                />
                <AdminSelect
                  value={availability}
                  options={availabilityOptions}
                  onChange={({ target }: { target: HTMLSelectElement }) => {
                    setAvailability(target.value as Availability);
                  }}
                  label="Availability"
                  $textCenter
                />
                <Div $flex $gap="16px">
                  <Icon $pointer onClick={handleExpand}>
                    <XCircleIcon />
                  </Icon>
                  <Icon $pointer onClick={handleAddOption}>
                    <CheckCircleIcon />
                  </Icon>
                </Div>
              </Div>
            </div>
          </Collapsible>

          {options.length > 0 && (
            <Div $flex $column $gap="16px">
              {options.map((o, i) => {
                return (
                  <ModifierBoxComponent
                    option={o}
                    key={i}
                    handleRemoveOption={handleRemoveOption}
                    i={i}
                  />
                );
              })}
            </Div>
          )}
        </div>

        {optionGroup === ModifierType.Option && (
          <>
            <AdminSelect
              value={isRequired}
              options={requiredOptionsGroup}
              onChange={({ target }: { target: HTMLSelectElement }) =>
                handleChangeIsRequired(target.value as 'true' | 'false')
              }
              label="Required Choice?"
              $textCenter
            />
            <AdminSelect
              value={choices}
              options={choicesOptionsGroup}
              onChange={({ target }: { target: HTMLSelectElement }) => {
                handleChangeChoices(
                  target.value as 'Only One' | 'Set a min-max'
                );
              }}
              label="How many choices can customer select?"
              $textCenter
            />
          </>
        )}

        {optionGroup === ModifierType.Option && choices === 'Set a min-max' && (
          <Div $flex $alignCenter $gap="16px" $width="100%">
            <AdminInput
              placeholder="Enter Here"
              label="Minimum Qty"
              $textCenter
              value={selectionsMin ?? ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSelectionsMin(Number(e.target.value))
              }
              type="number"
              min={required ? '1' : '2'}
            />
            <AdminInput
              placeholder="Enter Here"
              label="Maximum Qty"
              $textCenter
              value={selectionsMax ?? ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSelectionsMax(Number(e.target.value))
              }
              type="number"
            />
          </Div>
        )}
        <div>
          <Button $selected $w="100%" onClick={handleAddModifierGroup}>
            Confirm
          </Button>
          <Button
            $selected
            $mt="16"
            $gray
            $w="100%"
            onClick={() => closeModal?.()}
          >
            Cancel
          </Button>
        </div>
      </Div>
    </Modal>
  );
};
